import React, { Component } from 'react';
interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}
// Top-level safety net. Without this, ANY component that throws during
// render unmounts the entire React tree and the page renders blank white —
// which on a published site looks like "the site randomly won't load."
// This catches the throw, logs it, and shows a recoverable fallback with a
// reload button instead of a dead white screen.
export class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false
  };
  static getDerivedStateFromError(): State {
    return {
      hasError: true
    };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Surface the real cause in the console so it can be diagnosed.
    console.error('App crashed during render:', error, info);
  }
  handleReload = () => {
    this.setState({
      hasError: false
    });
    if (typeof window !== 'undefined') window.location.reload();
  };
  render() {
    if (this.state.hasError) {
      return <div className="min-h-screen flex flex-col items-center justify-center gap-5 bg-[#fdfbf7] px-6 text-center" data-id="element-747" data-mp="3n5t4kcsv5bay">
          <div className="max-w-md" data-id="element-748" data-mp="3s6gsgplspc0y">
            <h1 className="text-2xl font-extrabold text-stone-900" data-id="element-749" data-mp="3dfzslaot6u66">
              Something went wrong loading the page
            </h1>
            <p className="mt-2 text-stone-600" data-id="element-750" data-mp="3id9nh5uyvy1e">
              Please reload to try again. If it keeps happening, give us a call
              at (206) 619-3742 and we'll take your order over the phone.
            </p>
          </div>
          <button type="button" onClick={this.handleReload} className="px-6 py-3 rounded-lg bg-[#04A05C] text-white font-bold hover:bg-[#17A347] transition-colors" data-id="element-751" data-mp="38e22bwhzqz3q">
            Reload page
          </button>
        </div>;
    }
    return this.props.children;
  }
}